import styled from "styled-components";

const InputSearch = styled.input`
  width: 100%;
  height: 100%;
  border: none;
  padding: 5px;
  font-size: 16px;
`;

export default InputSearch;
